import { action, observable, toJS, makeObservable } from 'mobx';
import _ from 'lodash';

class FilterRowViewModel {
  category;
  operators = [];
  row;
  editingRow;
  viewOnly = false;

  constructor({category, attribute, operators}) {
    makeObservable(this, {
      category: observable,
      operators: observable,
      row: observable,
      editingRow: observable,
      viewOnly: observable,
      editOperator: action,
      updateRow: action,
      resetRow: action
    });

    this.category = category;
    this.operators = [...operators];
    this.row = this.createRow();
    this.row.attribute = attribute;
    this.row.operator = this.operators[0];
    this.editingRow = this.createRow(this.row);
  }

  createRow(row) {
    throw new Error('Child class must implement createRow()');
  }

  editOperator(operator) {
    this.editingRow.operator = operator;
  }

  updateRow() {
    this.row = this.createRow(this.editingRow);
  }

  resetRow() {
    this.editingRow = this.createRow(_.cloneDeep(toJS(this.row)));
    setTimeout(() => {
      this.searchFilter = '';
    }, 200);
  }
}

export default FilterRowViewModel;
